/**
 * Теги под плиткой референса или папки модели: до `TILE_TAGS` штук цветом `tagStyle`,
 * остальные — «+N» с полным списком в подсказке (как в сетке пинов). Общая для
 * `ReferenceGrid` и `ModelFolderTile`; тегов нет — ничего не рисует. Метка, что поставил
 * только автотег (`autoIds`), — с пунктирной рамкой и подсказкой «авто · по промпту».
 */
import { AUTO_MARK, AUTO_TITLE } from "@/lib/autotag";
import { tagStyle } from "@/lib/tags";

/** Сколько тегов видно на плитке, остальные — «+N». */
const TILE_TAGS = 3;

export function TileTags({
  tagIds,
  tagNames,
  autoIds,
}: {
  tagIds: readonly number[];
  tagNames: ReadonlyMap<number, string>;
  /** Из `tagIds` — метки только от автотега. */
  autoIds?: readonly number[] | undefined;
}) {
  if (!tagIds.length) return null;
  const auto = new Set(autoIds ?? []);
  return (
    <span className="flex min-w-0 flex-wrap gap-1" data-annot="теги плитки">
      {tagIds.slice(0, TILE_TAGS).map((id) => (
        <span
          key={id}
          className="max-w-full truncate rounded-[3px] px-1 text-[10.5px] leading-[16px]"
          style={auto.has(id) ? { ...tagStyle(id), ...AUTO_MARK } : tagStyle(id)}
          title={auto.has(id) ? `${tagNames.get(id) ?? `#${id}`} — ${AUTO_TITLE}` : undefined}
        >
          {tagNames.get(id) ?? `#${id}`}
        </span>
      ))}
      {tagIds.length > TILE_TAGS ? (
        <span
          className="text-[10.5px] leading-[16px] text-fg-muted"
          title={tagIds
            .slice(TILE_TAGS)
            .map((id) => (tagNames.get(id) ?? `#${id}`) + (auto.has(id) ? " (авто)" : ""))
            .join(", ")}
        >
          +{tagIds.length - TILE_TAGS}
        </span>
      ) : null}
    </span>
  );
}
